import { FormRow } from '../../components';
import PropTypes from 'prop-types'; // Add missing import statement

const BirthdayMessageDetails = ({ formData, handleInputChange }) => {
  return (
    <>
      <FormRow
        type='text'
        name='birthdayDetails.celebratorName'
        labelText='שם המציין'
        defaultValue={formData.celebratorName}
        value={formData.celebratorName}
        handleChange={handleInputChange}
      />
      <FormRow
        type='text'
        name='birthdayDetails.greeting'
        labelText='ברכה'
        defaultValue={formData.greeting}
        value={formData.greeting}
        handleChange={handleInputChange}
      />

      <FormRow
        type='date'
        name='birthdayDetails.birthdayDate'
        labelText='תאריך יום ההולדת'
        defaultValue={formData.birthdayDate}
        value={formData.birthdayDate}
        handleChange={handleInputChange}
      />
    </>
  );
};

BirthdayMessageDetails.propTypes = {
  formData: PropTypes.object.isRequired,
  handleInputChange: PropTypes.func.isRequired,
};

export default BirthdayMessageDetails;
